import { useEffect, useState } from 'react';
import first from 'lodash.first';
import { useDispatch } from 'react-redux';

import { loadGeneralSettings } from 'redux/reducers/generalSettings';
import { IBreakdown, ISocialData } from './../types';

function useSocialData(
  socialData: ISocialData[],
  activeMetric: string
): IBreakdown[] {
  const [socialRows, setSocialRows] = useState([]);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadGeneralSettings());
  }, [dispatch]);

  useEffect(() => {
    if (socialData && activeMetric) {
      const sortByActiveMetric = sortByMetric(activeMetric);
      const platforms = first<any>(socialData).data;
      const rows = platforms.filter(filterByRtd).sort(sortByActiveMetric);

      setSocialRows(rows);
    }
  }, [socialData, activeMetric]);

  return socialRows;
}

function filterByRtd(platform: IBreakdown): boolean {
  return platform.countRtd !== null;
}

function sortByMetric(metric: string): any {
  return function (a: IBreakdown, b: IBreakdown): number {
    return b[metric] - a[metric];
  };
}

export default useSocialData;
